import { graphql } from '@/generated/gql';

export const INTAKE_CHAT_REQUEST_DESCRIPTION_STEP_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeChatRequestDescriptionStepMutation($data: SvbrgRequestDescriptionInput!) {
    sevenbridges {
      chatSession {
        requestDescription {
          createInChat(data: $data) {
            id
            language
            text
          }
        }
      }
    }
  }
`);
